import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize, normalizedDelete} from '../../util/utils';

export function controlsDetailsReducer(state = initialstate.controlsDetails, action) {
	switch (action.type) {
		case types.GET_CONTROL_BY_ID:
			return action.response || state;
		case types.CLEAN_CONTROL_DETAILS:
			return {};
		default:
			return state;
	}
}

// Reducer for the list of all controls
export function controlsReducer(state = initialstate.controls, action) {
	let newState;

	switch (action.type) {
		case types.GET_ALL_CONTROLS: {
			if (action.response && action.response.data) {
				newState = {...state};

				const controlList = normalize(action.response.data.map((control) => control));
				controlList.pages = action.response.pages;
				controlList.page = action.response?.page;
				controlList.totalEntityCount = action.response.totalEntityCount;
				newState = {...controlList};
				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}

export function walkthroughControlsReducer(state = initialstate.controls, action) {
	let newState;

	switch (action.type) {
		case types.GET_ALL_CONTROLS_SAME_API_SORTING: {
			if (action.response && action.response.data) {
				newState = {...state};
				const controlList = {
					controlData: action.response.data
				};
				controlList.pages = action.response.pages;
				controlList.page = action.response?.page;
				controlList.totalEntityCount = action.response.totalEntityCount;

				newState = {...controlList};
				return newState;
			}
			return state;
		}
		default:
			return state;
	}
}
